import { render, staticRenderFns } from "./BellDropdown.vue?vue&type=template&id=0706a533&scoped=true"
import script from "./BellDropdown.vue?vue&type=script&lang=js"
export * from "./BellDropdown.vue?vue&type=script&lang=js"
import style0 from "./BellDropdown.vue?vue&type=style&index=0&id=0706a533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0706a533",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
